import React from "react";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

const CircleCheckboxRoot = styled("span")`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`;

const CircleIcon = styled("svg")`
  width: 16px;
  height: 16px;
`;

const UncheckedIcon = () => (
  <CircleIcon
    fill="none"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.06253" fill="white" r="7.5" stroke="#1A509B" />
  </CircleIcon>
);

const CheckedIcon = () => (
  <CircleIcon
    fill="none"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.06253" fill="white" r="7.5" stroke="#1A509B" />
    <circle cx="8" cy="8.06253" fill="#1A509B" r="4" />
  </CircleIcon>
);

const CircleCheckbox = (props: CheckboxProps) => {
  return (
    <CircleCheckboxRoot>
      <Checkbox
        checkedIcon={<CheckedIcon />}
        icon={<UncheckedIcon />}
        inputProps={{ "aria-label": "circle checkbox" }}
        disableRipple
        {...props}
        sx={{
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      />
    </CircleCheckboxRoot>
  );
};

export default CircleCheckbox;
